import React, { useContext, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { AppContext } from "../../contaxt/AppContext";
import { simplePostCall } from "../../api/ApiServices";
import ApiConfig from "../../api/ApiConfig";
import { lungueges } from "../../constant/lungueges";

const DropdownLanguage = ({ showDropDown, setShowDropDown }) => {
  const { SetChangeLang, ChangeLang } = useContext(AppContext);
  const { i18n, t } = useTranslation();

  const [language, setLanguage] = useState(
    localStorage.getItem("language") || "en"
  );

  useEffect(() => {
    i18n.changeLanguage(ChangeLang);
  }, [i18n, ChangeLang]);

  const handleLangChange = (lang) => {
    SetChangeLang(lang);
    localStorage.setItem("language", lang);
    i18n.changeLanguage(lang);
    setShowDropDown(false);

    simplePostCall(
      ApiConfig?.UPDATE_LANG +
      `userId=${localStorage.getItem("customer_id")}&language=${lang}`
    ).then((res) => {
      if (res?.succeded) {
        console.log("success");
      }
    });
  };

  const currentLanguage = localStorage.getItem("language");

  return (
    <div style={{ maxHeight: '300px', overflow: 'scroll' }}>
      {/* <div
         className="lang-style text-muted"
        style={{
          backgroundColor: currentLanguage === "sel" ? "#444CE7" : "transparent",
          color: currentLanguage === "sel" ? "grey" : "grey",
        }}
      >
        Select Language
      </div> */}
      {
        Object.keys(lungueges)?.map((key, index) => {

          return <div
            key={index}
            onClick={() => handleLangChange(key)}
            className="lang-style"
            style={{
              backgroundColor: ChangeLang === key ? "#444CE7" : "transparent",
              color: ChangeLang === key ? "white" : "black",
            }}
          >
            {lungueges[key]}
          </div>

        })
      }



    </div>
  );
};

export default DropdownLanguage;
